function ConsultantDashboard() {
  return <div>Consultant Dashboard</div>;
}

export default ConsultantDashboard;
